<template lang="html">
    <div id="page__prices__forwarding" class="center-panel" v-bind:loading="progress">
        <md-content class="md-elevation-1" md-theme="white">    
            <sort-table
                v-bind:columns="tableColumns" v-model="prices" @refresh="getPrices" v-bind:per-page="perPage" 
                v-bind:total="pricesAmount" link table-id="forwardingprices" ref="table" v-on:create="addPrice"
            >
                <template slot="city" slot-scope="scope"> 
                    <span no-breack-words> {{ scope.item.city ? scope.item.city.name : 'Не установлен' }}</span>
                </template>

                <template slot="street_value" slot-scope="scope"> 
                    <span no-breack-words> {{ scope.item.street_value ? scope.item.street_value : 'Не установлена' }}</span>
                </template>

                <template slot="type" slot-scope="scope"> {{ parseInt(scope.item.type) == 2 ? 'По объёму' : 'По весу' }}</template>

                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'clone']"  v-on:click.stop.prevent="clone(scope.item.id)" rounded></z-icon-button>
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>

<script>
    import SortTable from '@/components/SortTable';
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: { SortTable, ZIconButton },
        data() {
            return {
                perPage: 50,
                tableColumns: [
                    { label: 'ID', field: 'id', sortable: true },
                    { label: 'Город', field: 'city' },
                    { label: 'Улица', field: 'street_value' },
                    { label: 'Тип расчёта', field: 'type' },
                    { label: 'Мин. вес/объём', field: 'value_min' },
                    { label: 'Макс. вес/объём', field: 'value_max' },
                    { label: 'Цена', field: 'price' },
                    { label: '', field: 'actions' },
                ]
            }
        },
        computed: {
            /**
             * Список цен
             */
            prices() {
                return this.$store.state.cost.forwarding_prices.map(price => {
                    price.routerLink = { name: 'ForwardingPrice', params: { price_id: price.id }, query: this.$route.query };
                    return price;
                });
            },
            /**
            * Флаг загрузки текущего компонента
            */
            progress() {
                return this.progressObj['get-forwards-list'];
            },
            /**
            * Объект с флагами загрузки
            */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Количество цен
             */
            pricesAmount() {
                return this.$store.state.cost.forwarding_prices_amount
            }
        },
        created() {
            this.$store.commit('setTitle', 'Цены экспедирования')
        },
        methods: {
            /**
             * Добавить цену
             */
            addPrice() {
                this.$router.push({ name: 'ForwardingPrice', params: { price_id: 'new' } });
            },
            /**
             * Клонирование
             */
            clone(id) {
                let query = Object.assign({}, this.$route.query);
                if (query) query.clone_id = id;
                else query = {clone_id: id};

                this.$router.push({ name: 'ForwardingPrice', params: { price_id: 'new' }, query: query});
            },
            /**
             * Получение цен
             */
            getPrices(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', 'get-forwards-list');
                this.$store.dispatch('cost/getForwardingPrices',{
                    page: page, 
                    order_by: orderBy, 
                    order_type: orderType, 
                    count: count, 
                    filter: this.resolveQueryFilter()
                }).finally(() => this.$store.commit('hideProgressBar', 'get-forwards-list'));
            },
            /**
             * Фильтрация
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return null;
                let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: [], relation: [], condition: 'and'};

                if (filter.type) model.push(['type', '=', filter.type]);
                if (filter.city_id) model.push(['city_id', '=', filter.city_id]);

                model.map((item, i) => {
                    result.model.push(item);
                    if (model[i+1]) result.model.push('and');
                });
                return result
            },
            /**
             * Удаление цены
             */
            removePrice(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'get-forwards-list');
                this.$store.dispatch('cost/deleteForwardingPrice', id)
                    .then(() => this.$root.$emit('refresh-table', 'forwardingprices'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-forwards-list'));
            },
            /**
             * Модальное окно с удалением цены
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении цены?', 'Действие необратимо!',
                    () => this.removePrice(id)
                );
            }
        },
    }
</script>


// WEBPACK FOOTER //
// ForwardingPrices.vue?c6907056